import React from "react";
import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Team } from "../../../types/team";
import TeamMemberTable from "../../../components/tables/TeamMemberTable";
import useTeamMemberController from "../../../controllers/connections/teamMemberConnectionController";

interface TeamMemberConnectionsSectionProps {
  team: Team;
}

const TeamMemberSection: React.FC<TeamMemberConnectionsSectionProps> = ({
  team,
}) => {
  const controller = useTeamMemberController({
    from: team,
    systemLanguageType: team.system_language_type,
  });
  const { openCreateDialog } = controller;
  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box
          sx={{
            mb: 4,
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            sx={{
              position: "absolute",
              left: 16,
            }}
            startIcon={<AddIcon />}
            onClick={() => openCreateDialog()}
          >
            New Team Member
          </Button>
          <Typography variant="h2">Team Members</Typography>
        </Box>
        <TeamMemberTable
          filters={{ system_language_type: team.system_language_type }}
          controller={controller}
        />
      </Box>
    </>
  );
};

export default TeamMemberSection;
